import { render, staticRenderFns } from "./TheKitItemsPanel.vue?vue&type=template&id=20f8cb4b&scoped=true"
import script from "./TheKitItemsPanel.vue?vue&type=script&lang=js"
export * from "./TheKitItemsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheKitItemsPanel.vue?vue&type=style&index=0&id=20f8cb4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8cb4b",
  null
  
)

export default component.exports